import { Col, Row } from "reactstrap";
import Gauge from "../commons/Guage";
// import Gauge2 from "../commons/Guage2";
// import Gauge3 from "../commons/Guage3";
import DailyGraph from "../commons/DailyGraph";
import MonthlyGraph from "../commons/MonthlyGraph";
import YearlyGraph from "../commons/YearlyGraph";
import PurchaseDailyGraph from "../commons/PurchaseDailyGraph";
import PurchaseMonthlyGraph from "../commons/PurchaseMonthlyGraph";
import PurchaseYearlyGraph from "../commons/PurchaseYearlyGraph";
import { SchoolContext } from "../context/SchoolContext";
import { useContext, useEffect, useState } from "react";
import SoldDailyGraph from "../commons/SoldDailyGraph";
import SoldMonthlyGraph from "../commons/SoldMonthlyGraph";
import SoldYearlyGraph from "../commons/SoldYearlyGraph";
import ConsumpDailyGraph from "../commons/ConsumpDailyGraph";
import ConsumpMonthlyGraph from "../commons/ConsumpMonthlyGraph";
import ConsumpYearlyGraph from "../commons/ConsumpYearlyGraph";
import Spinner from "../commons/Spinner";
import { getCurrentData, getDeviceConfig, getDeviceId, getHistoryData, getWeatherData } from "../api/api";
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { formatMass, formatValue, formatNumber, formatArray, roundToNearest, idExists } from "../utils/NumberUtils";
import weatherCode from "../utils/WeatherCode";
import { useHistory } from "react-router-dom";


const Home = () => {

    const { schoolList, setSchool } = useContext(SchoolContext);
    const [currentData, setCurrentData] = useState();
    const [weather, setWeather] = useState();
    const [daily, setDaily] = useState();
    const [monthly, setMonthly] = useState();
    const [yearly, setYearly] = useState();
    const [isloading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem('accessToken');
    // const [deviceId, setDeviceId] = useState(null);
    const convertToZonedTime = (date) => {
        return utcToZonedTime(date.toISOString(), 'Asia/Tokyo');
    };
    const date = convertToZonedTime(new Date());
    const [deviceStatus, setDeviceStatus] = useState();
    const [status, setStatus] = useState();
    const [powerGene, setPowerGene] = useState(false);
    const [consumPower, setconsumPower] = useState(false);
    const history = useHistory();
    const pathname = history["location"].pathname
    const schoolId = Number(pathname.split('/').pop());

    useEffect(() => {
        if (schoolList.length > 0) {
            if (idExists(schoolList, schoolId)) {
                setIsLoading(true);
                setSchool(Number(schoolId));
                const controller = new AbortController();
                const signal = controller.signal;

                const fetchWeather = async (signal) => {
                    const res = await getDeviceId(schoolList[schoolId - 1].place_id, authToken, signal);

                    if (res && res.sems_device_id) {
                        // Storing school Id and Device Id in LocalStorage
                        const value = localStorage.getItem('schools');
                        const schools = value ? JSON.parse(value) : [];
                        const schoolObj = { id: schoolId, device_id: res.sems_device_id };
                        if (schools && !schools.some(obj => obj.id === schoolObj.id)) {
                            schools.push(schoolObj);
                            localStorage.setItem('schools', JSON.stringify(schools));
                        }
                        const power = await getCurrentData(authToken, res.sems_device_id, signal);
                        setCurrentData(power);
                        const data = await getWeatherData(authToken, res.sems_device_id, schoolList[schoolId - 1].place_id, signal);
                        setWeather(data);
                        const status = await getDeviceConfig(authToken, res.sems_device_id, { configType: 'network_config' }, signal);
                        setDeviceStatus(status)
                        const dates = [`${format(date, 'yyyy-MM-dd')}`, `${format(date, 'yyyy-MM')}`, `${format(date, 'yyyy')}`];
                        const timePeriod = ['day', 'month', 'year'];
                        const historyDay = await getHistoryData(authToken, timePeriod[0], dates[0], res.sems_device_id, signal);
                        const historyMonth = await getHistoryData(authToken, timePeriod[1], dates[1], res.sems_device_id, signal);
                        const historyYear = await getHistoryData(authToken, timePeriod[2], dates[2], res.sems_device_id, signal);
                        setDaily(historyDay);
                        setMonthly(historyMonth);
                        setYearly(historyYear);
                    } else {
                        setWeather(null);
                    }
                    // setIsLoading(false);
                    setIsLoading(false);
                }
                const interval = setInterval(() => {
                    fetchWeather(signal);
                }, 60000);
                fetchWeather(signal);
                return () => {
                    clearInterval(interval);
                    controller.abort();
                };
            } else {
                history.push('/home')
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, schoolId])

    useEffect(() => {
        if (deviceStatus && deviceStatus !== null) {
            let count = {
                C: 0, W: 0, E: 0, G: 0
            }
            deviceStatus.forEach((data, index) => {
                if (data.work_status !== null) {
                    if (data.event_type.length === 0) {
                        count.G += 1;
                    }
                    else if (data.event_type.includes("W") && data.event_type.includes("E")) {
                        count.E += 1;
                    } else {
                        data.event_type.forEach(eventType => {
                            if (eventType === "E") {
                                count.E += 1;
                            } else if (eventType === "C") {
                                count.C += 1;
                            } else if (eventType === "W") {
                                count.W += 1;
                            } else {
                                count.G += 1;
                            }
                        });
                    }
                }
                else {
                    count.C += 1;
                }
            })
            setStatus(count);
        }
    }, [deviceStatus])

    useEffect(() => {
        if (!!monthly && monthly !== null) {
            if (monthly.power_gene_str && monthly.power_gene_str.length > 1) {
                if (monthly.power_gene_str[monthly.power_gene_str.length - 1] > monthly.power_gene_str[monthly.power_gene_str.length - 2]) {
                    setPowerGene(true);
                }
            }
            if (monthly.consumption_power && monthly.consumption_power.length > 1) {
                if (monthly.consumption_power[monthly.consumption_power.length - 1] > monthly.consumption_power[monthly.consumption_power.length - 2]) {
                    setconsumPower(true);
                }
            }
        }
    }, [monthly])

    const weatherIcon = weather && weather.forecast ? weatherCode(weather.forecast.today.weather_code) : "";
    const tom_weatherIcon = weather && weather.forecast ? weatherCode(weather.forecast.tomorrow.weather_code) : "";
    const co2Format = monthly && monthly.co2 && monthly.co2.length !== 0 ? (typeof monthly.co2[monthly.co2.length - 1] === "string") ? { newVal: "---", unit: "g" } : formatMass(monthly.co2[monthly.co2.length - 1]) : { newVal: "---", unit: "g" };
    const unitCo2 = currentData && currentData !== null && currentData.co2 && currentData.co2.value !== null ? formatMass(currentData.co2.value) : { newVal: "---", unit: "g" }
    // const GeneratedPower = monthly && monthly.power_gene_str && monthly.power_gene_str.length !== 0 ? (typeof monthly.power_gene_str[monthly.power_gene_str.length - 1] === "string") ? 0 : monthly.power_gene_str[monthly.power_gene_str.length - 1] : 0;
    // const DischargePower = monthly && monthly.dischrg_power && monthly.dischrg_power.length !== 0 ? (typeof monthly.dischrg_power[monthly.dischrg_power.length - 1] === "string") ? 0 : monthly.dischrg_power[monthly.dischrg_power.length - 1] : 0;
    // const TransPower = monthly && monthly.trans_power && monthly.trans_power.length !== 0 ? (typeof monthly.trans_power[monthly.trans_power.length - 1] === "string") ? 0 : monthly.trans_power[monthly.trans_power.length - 1] : 0;
    // const ConsumptionPower = monthly && monthly.consumption_power && monthly.consumption_power.length !== 0 ? (typeof monthly.consumption_power[monthly.consumption_power.length - 1] === "string") ? 0 : monthly.consumption_power[monthly.consumption_power.length - 1] : 0;
    const percentage = daily && daily.self_sufficiency_rate && daily.self_sufficiency_rate !== null ? daily.self_sufficiency_rate : '---';
    const purchaseMaxDaily = daily && !!daily && Object.keys(daily).length !== 0 ? formatArray(daily.recv_power) : 10000;
    const purchaseMaxMonthly = monthly && !!monthly && Object.keys(monthly).length !== 0 ? formatArray(monthly.recv_power) : 100000;
    const purchaseMaxYearly = yearly && !!yearly && Object.keys(yearly).length !== 0 ? formatArray(yearly.recv_power) : 100000;
    const soldMaxDaily = daily && !!daily && Object.keys(daily).length !== 0 ? formatArray(daily.trans_power) : 10000;
    const soldMaxMonthly = monthly && !!monthly && Object.keys(monthly).length !== 0 ? formatArray(monthly.trans_power) : 100000;
    const soldMaxYearly = yearly && !!yearly && Object.keys(yearly).length !== 0 ? formatArray(yearly.trans_power) : 1000000;
    const maxDaily = daily && !!daily && Object.keys(daily).length !== 0 ? formatArray(daily.power_gene_str) : 10000;
    const maxMonthly = monthly && !!monthly && Object.keys(monthly).length !== 0 ? formatArray(monthly.power_gene_str) : 100000;
    const maxYearly = yearly && !!yearly && Object.keys(yearly).length !== 0 ? formatArray(yearly.power_gene_str) : 1000000;
    const consumptionMaxDaily = daily && !!daily && Object.keys(daily).length !== 0 ? formatArray(daily.consumption_power) : 10000;
    const consumptionMaxMonthly = monthly && !!monthly && Object.keys(monthly).length !== 0 ? formatArray(monthly.consumption_power) : 100000;
    const consumptionMaxYearly = yearly && !!yearly && Object.keys(yearly).length !== 0 ? formatArray(yearly.consumption_power) : 1000000;
    const maxDataDaily = roundToNearest(Math.max(purchaseMaxDaily, soldMaxDaily, maxDaily, consumptionMaxDaily), 100000);
    const maxDataMonthly = roundToNearest(Math.max(purchaseMaxMonthly, soldMaxMonthly, maxMonthly, consumptionMaxMonthly), 100000);
    const maxDataYearly = roundToNearest(Math.max(purchaseMaxYearly, soldMaxYearly, maxYearly, consumptionMaxYearly), 1000000);

    return <>
        {isloading ? <Spinner />
            : <div className=" container-fluid gradient1bg ">
                <Row className="home-margin">
                    <Col className=" home_box_shadow boxes-margin home-border box-margin gauge-box">
                        <Row>
                            <Col className="heading-margin">
                                <span className=" text__large noCursor">バッテリー情報</span><span onClick={() => { history.push(`/home/device/${schoolId}`) }}><img src="/img/side_arrow.png" className="sideArrow" alt="sideArrow"></img></span>
                            </Col>
                        </Row>
                        <Row className="d-flex flex-column">
                            {/* <Col className="marginT1 guageImageBox1 text-center">
                                {
                                    currentData && currentData !== null ? <Gauge3 value={currentData} /> : ""
                                }
                            </Col> */}
                            <Col className="marginT1 guageImageBox text-center">
                                {
                                    currentData && currentData !== null ? <Gauge value={currentData} /> : <Gauge />
                                }
                            </Col>

                            <Col className="marginT5 px-4">
                                <span className="text__larger">バッテリー残容量 : </span>
                                <span className="text__larger" >{currentData && currentData !== null && currentData.bat_pcs && currentData.bat_pcs.bat_remain_capacity !== null ? formatValue(currentData.bat_pcs.bat_remain_capacity) : "---"}</span>
                                <span className="text__larger">kWh</span>
                            </Col>


                        </Row>
                    </Col>
                    <Col className=" home_box_shadow boxes-margin home-border box-margin weather-box">
                        <Row>
                            <Col className="heading-margin">
                                <span className="text__large noCursor">天気情報</span>
                            </Col>
                        </Row>
                        <Row className="marginT3">
                            <Col className="col-6" md={5}>
                                <span className="text__larger">現在</span><br />
                                <img src={'/img/' + weatherIcon + '.png'} alt="weather" className="weatherImage" width={weatherIcon === '1-0' || weatherIcon === '2-0' || weatherIcon === '3-0' || weatherIcon === '4-0' ? "30px" : "60px"} />
                            </Col>
                            <Col className="col-6" md={7}>
                                <span className="numberVal">{weather ? weather.temperature !== null ? weather.temperature.toFixed(1) : weather.forecast && weather.forecast.temp !== null ? weather.forecast.temp : "---" : "---"}
                                </span><span className="units">°C</span>
                            </Col>
                        </Row>

                        <Row className="d-flex flex-row marginT3 weatherData-box">
                            <Col md={5} className="col-6">
                                <span className="text__larger">明日</span><br />
                                <img src={'/img/' + tom_weatherIcon + '.png'} alt="weather" className="weatherImage" width={tom_weatherIcon === '1-0' || tom_weatherIcon === '2-0' || tom_weatherIcon === '3-0' || tom_weatherIcon === '4-0' ? "30px" : "60px"} />
                            </Col>
                            <Col className="d-flex flex-column col-6" md={7}>
                                <span className="numberVal1 ">{weather && weather.forecast ? weather.forecast.tomorrow.max_temp !== null ? weather.forecast.tomorrow.max_temp : "---" : "---"}<span className="units">°C</span></span>
                                {/* <span className="mt-4 units">°C</span> */}
                                <span className="numberVal2">{weather && weather.forecast ? weather.forecast.tomorrow.min_temp !== null ? weather.forecast.tomorrow.min_temp : "---" : "---"}<span className="units">°C</span></span>
                                {/* <span className=" marginT2 units ">°C</span> */}
                            </Col>
                        </Row>

                        <Row className="marginweather">
                            <Col md={12}>
                                <span className="text__larger">日射強度</span>
                            </Col>
                            <Col md={12}> <span className="co2">{weather ? weather.solar_radiation !== null ? weather.solar_radiation.toFixed(1) : "---" : "---"}W/㎡</span> </Col>
                        </Row>
                        <Row className="marginweather">
                            <Col md={12}>
                                <span className="text__larger">本日の再エネ自給率</span>
                            </Col>
                            <Col md={12}>
                                <span className="co2">{typeof percentage === 'string' ? percentage : formatNumber(percentage, 2)}%</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col className=" home_box_shadow boxes-margin paddingT5 flex-column box-margin home-border purchaseGraph">
                        {/* {currentData && daily && monthly && yearly && <>
                            <PurchaseDailyGraph current={currentData} daily={daily} max={maxDataDaily} />
                            <PurchaseMonthlyGraph monthly={monthly} max={maxDataMonthly} />
                            <PurchaseYearlyGraph yearly={yearly} max={maxDataYearly} />
                        </>} */}
                        {currentData && daily ? <PurchaseDailyGraph current={currentData} daily={daily} max={maxDataDaily} /> : <PurchaseDailyGraph />}
                        {monthly ? <PurchaseMonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <PurchaseMonthlyGraph />}
                        {yearly ? <PurchaseYearlyGraph yearly={yearly} max={maxDataYearly} /> : <PurchaseYearlyGraph />}
                    </Col>


                    <Col className=" home_box_shadow boxes-margin paddingT5 flex-column box-margin home-border soldGraph">
                        {/* {currentData && daily && monthly && yearly && <>
                            <SoldDailyGraph current={currentData} daily={daily} max={maxDataDaily} />
                            <SoldMonthlyGraph monthly={monthly} max={maxDataMonthly} />
                            <SoldYearlyGraph yearly={yearly} max={maxDataYearly} />
                        </>} */}

                        {currentData && daily ? <SoldDailyGraph current={currentData} daily={daily} max={maxDataDaily} /> : <SoldDailyGraph />}
                        {monthly ? <SoldMonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <SoldMonthlyGraph />}
                        {yearly ? <SoldYearlyGraph yearly={yearly} max={maxDataYearly} /> : <SoldYearlyGraph />}
                    </Col>

                    {/* </Row>

                <Row className="home-margin"> */}
                    <Col className=" box-margin home-border info-table-box">
                        <Row className="d-flex flex-column home_box_shadow boxes-margin home-border lower-box">
                            <div className="heading-margin">
                                <span className="text__large noCursor">デバイス状況</span><span onClick={() => { history.push(`/home/device/${schoolId}`) }}><img src="/img/side_arrow.png" alt="arrow" className="sideArrow"></img></span>
                            </div>
                            <div className="px-4 d-flex flex-row">
                                <div className="tableFirst">
                                    <Row className="marginT2 text-margin">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="green" className="bi bi-check-circle marginT1" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                                        </svg>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" className="bi bi-x-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ffba00" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                                        </svg>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                        </svg>
                                    </Row>
                                </div>
                                <div className="tableSecond">
                                    <Row className="marginT2 text-margin">
                                        <span className="text__larger"> 正常</span>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <span className="text__larger"> エラー</span>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <span className="text__larger"> 警告</span>
                                    </Row>
                                    <Row className="marginT2 text-margin">
                                        <span className="text__larger"> 通信エラー</span>
                                    </Row>
                                </div>
                                <div className="tableLast">
                                    <Row className="marginT2 text-margin d-flex justify-content-end">
                                        <span className="text__larger ">{status ? status.G : "-"}台</span>
                                    </Row>
                                    <Row className="marginT2 text-margin d-flex justify-content-end">
                                        <span className="text__larger d-flex justify-content-end">{status ? status.E : "-"}台</span>
                                    </Row>
                                    <Row className="marginT2 text-margin d-flex justify-content-end">
                                        <span className="text__larger">{status ? status.W : "-"}台</span>
                                    </Row>
                                    <Row className="marginT2 text-margin d-flex justify-content-end">
                                        <span className="text__larger">{status ? status.C : "-"}台</span>
                                    </Row>
                                </div>
                            </div>
                        </Row>
                        <Row className=" marginT7 home_box_shadow d-flex flex-column boxes-margin home-border lower-box-co2">
                            <div className="title-box">
                                <span className="text__large">CO₂削減量</span>
                            </div>
                            <div className="co2-first">
                                <span className="text__larger">今日</span>
                                <span className=" ml-4 numberVal1 ">{co2Format.newVal}<span className="units">{co2Format.unit}</span></span>
                            </div>
                            <div className="co2-last">
                                <span className="text__larger">合計</span>
                                <span className="numberVal1 ml-4">{unitCo2.newVal}<span className="units">{unitCo2.unit}</span></span>
                            </div>
                        </Row>
                    </Col>
                    <Col className="home_box_shadow second-box boxes-margin box-margin home-border graphBox">
                        <Row>
                            <Col className="d-flex flex-column marginT2 col-12 boxes-margin graphInfoBox">
                                {/* {daily && monthly && yearly && <>
                                    <DailyGraph daily={daily} max={maxDataDaily} />
                                    <MonthlyGraph monthly={monthly} max={maxDataMonthly} />
                                    <YearlyGraph yearly={yearly} max={maxDataYearly} />
                                </>
                                } */}
                                {daily ? <DailyGraph daily={daily} max={maxDataDaily} /> : <DailyGraph />}
                                {monthly ? <MonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <MonthlyGraph />}
                                {yearly ? <YearlyGraph yearly={yearly} max={maxDataYearly} /> : <YearlyGraph />}
                            </Col>
                            <Col className="boxes-margin graphCircleBox">
                                <div className="graphCircle ">
                                    <span className="gauge-img">{currentData && currentData !== null && currentData.pv_pcs && currentData.pv_pcs.real_power !== null ? formatValue(currentData.pv_pcs.real_power) : "---"}</span>
                                    <span className="gauge-img-unit">kW</span>
                                </div>
                                <div className="circle-arrow">
                                    {powerGene ? <img src="/img/ArrowUp.png" alt="Arrow" height="45px" /> : <img src="/img/ArrowDown1.png" alt="Arrow" height="45px" />}
                                </div>

                            </Col>
                        </Row>
                    </Col>
                    <Col className=" box-margin home_box_shadow home-border graphConsump">
                        <Row>
                            <Col className="d-flex flex-column marginT2 boxes-margin graphInfoBox">
                                {/* {daily && monthly && yearly && <>
                                    <ConsumpDailyGraph daily={daily} max={maxDataDaily} />
                                    <ConsumpMonthlyGraph monthly={monthly} max={maxDataMonthly} />
                                    <ConsumpYearlyGraph yearly={yearly} max={maxDataYearly} />
                                </>} */}
                                {daily ? <ConsumpDailyGraph daily={daily} max={maxDataDaily} /> : <ConsumpDailyGraph />}
                                {monthly ? <ConsumpMonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <ConsumpMonthlyGraph />}
                                {yearly ? <ConsumpYearlyGraph yearly={yearly} max={maxDataYearly} /> : <ConsumpYearlyGraph />}
                            </Col>
                            <Col className="boxes-margin graphCircleBox">
                                <div className="graphCircleconsump ">
                                    <span className="gauge-img-consump">{currentData && currentData !== null && currentData.consumption && currentData.consumption.real_power !== null ? formatValue(currentData.consumption.real_power) : "---"}</span>
                                    <span className="gauge-img-unit-Consump">kW</span>
                                </div>
                                <div className="circle-arrow-consump">
                                    {consumPower ? <img src="/img/ArrowUp1.png" alt="Arrow" height="45px" /> : <img src="/img/ArrowDown.png" alt="Arrow" height="45px" />}
                                </div>

                            </Col>
                        </Row>

                    </Col>
                    <Col className="home_box_shadow second-box boxes-margin box-margin home-border graphBox2">
                        <Row>
                            <Col className="d-flex flex-column marginT2 col-12 boxes-margin graphInfoBox">
                                {/* {daily && monthly && yearly && <>
                                    <DailyGraph daily={daily} max={maxDataDaily} />
                                    <MonthlyGraph monthly={monthly} max={maxDataMonthly} />
                                    <YearlyGraph yearly={yearly} max={maxDataYearly} />
                                </>
                                } */}
                                {daily ? <DailyGraph daily={daily} max={maxDataDaily} /> : <DailyGraph />}
                                {monthly ? <MonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <MonthlyGraph />}
                                {yearly ? <YearlyGraph yearly={yearly} max={maxDataYearly} /> : <YearlyGraph />}
                            </Col>

                            <Col className="boxes-margin graphCircleBox">
                                <div className="graphCircle ">
                                    <span className="gauge-img">{currentData && currentData !== null && currentData.pv_pcs && currentData.pv_pcs.real_power !== null ? formatValue(currentData.pv_pcs.real_power) : "---"}</span>
                                    <span className="gauge-img-unit">kW</span>
                                </div>
                                <div className="circle-arrow">
                                    {powerGene ? <img src="/img/ArrowUp.png" alt="Arrow" height="45px" /> : <img src="/img/ArrowDown1.png" alt="Arrow" height="45px" />}
                                </div>

                            </Col>
                        </Row>
                    </Col>

                    <Col className=" box-margin home_box_shadow home-border graphConsump2">
                        <Row>
                            <Col className="d-flex flex-column marginT2 boxes-margin graphInfoBox">
                                {/* {daily && monthly && yearly && <>
                                    <ConsumpDailyGraph daily={daily} max={maxDataDaily} />
                                    <ConsumpMonthlyGraph monthly={monthly} max={maxDataMonthly} />
                                    <ConsumpYearlyGraph yearly={yearly} max={maxDataYearly} />
                                </>} */}
                                {daily ? <ConsumpDailyGraph daily={daily} max={maxDataDaily} /> : <ConsumpDailyGraph />}
                                {monthly ? <ConsumpMonthlyGraph monthly={monthly} max={maxDataMonthly} /> : <ConsumpMonthlyGraph />}
                                {yearly ? <ConsumpYearlyGraph yearly={yearly} max={maxDataYearly} /> : <ConsumpYearlyGraph />}
                            </Col>
                            <Col className="boxes-margin graphCircleBox">
                                <div className="graphCircleconsump ">
                                    <span className="gauge-img-consump">{currentData && currentData !== null && currentData.consumption && currentData.consumption.real_power !== null ? formatValue(currentData.consumption.real_power) : "---"}</span>
                                    <span className="gauge-img-unit-Consump">kW</span>
                                </div>
                                <div className="circle-arrow-consump">
                                    {consumPower ? <img src="/img/ArrowUp1.png" alt="Arrow" height="45px" /> : <img src="/img/ArrowDown.png" alt="Arrow" height="45px" />}
                                </div>

                            </Col>
                        </Row>

                    </Col>
                </Row>
            </div >}
    </>
}

export default Home;